import { useAuthQuery } from 'queries/query';
import { getQueryKeys } from 'queries/query-key';
import { HOLDER_KEY, KEY } from './keys';
import { StickerApi } from 'api';
import { SearchStickerHolderQueryType } from 'types';

function useGetHolders(id: number, query: SearchStickerHolderQueryType) {
  return useAuthQuery(
    getQueryKeys([KEY, HOLDER_KEY]).list({ id, ...query }),
    () => StickerApi.getHolders(id, query),
    {
      select: (data) => data.data,
    },
  );
}

export default useGetHolders;
